import styled from '@mui/material/styles/styled';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';

const StyledInput = styled(TextField)`
	& > .MuiInputBase-root > .MuiInputBase-input {
		text-align: center;

		&::-webkit-outer-spin-button,
		&::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		&[type='number'] {
			-moz-appearance: textfield;
			appearance: textfield;
		}
	}
`;

const StyledLink = styled(Link)`
	cursor: pointer;
`;

export {StyledInput, StyledLink};
